<template>
  <div>
    <div class="application4">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application4-1.jpg" alt />
          <img src="../../assets/images/application/application4-2.jpg" alt />
          <img src="../../assets/images/application/application4-3.jpg" alt />
          <img src="../../assets/images/application/application4-4.jpg" alt />
          <img src="../../assets/images/application/application4-5.jpg" alt />
          <img src="../../assets/images/application/application4-6.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application4">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>大型商场、产业园、商业地产类应用。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺按照租赁状态、到期情况、店铺行业、租金贡献、销售额、坪效等维度进行可视化展示分析；商场客流分析系统是基于大数据的分析理论，利用室内地图展示商场客流数据和顾客行为数据，利用统计图、热力图、轨迹等方式展现；公寓前台管理系统是整合租户信息和租赁状态，可视化管理单元信息及时解决客户要求，方便快捷实现报表展示和打印输出；日常经营分析系统包含营业额统计分析、店铺营业额对比分析、租期甘特图预警以及会员位置分析。</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 6" :key="index">
              <img :src="getImg(`application4-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application4",
  metaInfo: {
    title:
      "商业地产大数据可视化分析_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "商场地图可视化,地产可视化,商场全景VR,商场导航,跨楼层导航,商场客流分析,客流热力图,坪效分析,用户画像分析,商场精准营销"
      },
      {
        name: "description",
        content:
          "基于室内二三维地图可视化平台，实现商场单元可视化分析，客流热力分析，用户画像分析，商场定位导航，反向寻车，停车导航等功能，通过时空位置大数据AI分析，赋能智慧商场精准营销。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "商业地产大数据可视化分析",
        p:
          "臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "大型商场、产业园、商业地产类应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺按照租赁状态、到期情况、店铺行业、租金贡献、销售额、坪效等维度进行可视化展示分析；商场客流分析系统是基于大数据的分析理论，利用室内地图展示商场客流数据和顾客行为数据，利用统计图、热力图、轨迹等方式展现；公寓前台管理系统是整合租户信息和租赁状态，可视化管理单元信息及时解决客户要求，方便快捷实现报表展示和打印输出；日常经营分析系统包含营业额统计分析、店铺营业额对比分析、租期甘特图预警以及会员位置分析。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application4 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application4 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application4 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application4 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application4.vue